/**
 * функция просто чтобы вернуть объект. чтобы не писать много скобок в лямбдах
 */
export function just<T>(o: T): T {
    return o;
}

export function noop(...anyArgs: any) {
}

export type StringMap<T = any> = { [key: string]: T };

export function enumValues<T>(enumClass: T & any) {
    return Object
        .keys(enumClass)
        .map(key => just({key, value: enumClass[key]}))
        .filter(entry => /^[A-Z_]+$/.test(entry.key))
        .map(entry => entry.value)
}

export interface Provider<T> {
    (): T;
}